import _objectSpread from '@babel/runtime-corejs3/helpers/esm/objectSpread2';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/esm/objectWithoutProperties';
import { forwardRef } from 'react';
import { c as classNames } from '../../../shared/index-e39a0673.js';
import { renderIcon, renderNumber, renderLine, renderTitle, handleClick, handleKeydown } from '../shared/utils.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { Spacer } from '../../Spacer/Spacer.js';
import { Text } from '../../Text/Text.js';

var styles = {
  "unit-base": "4",
  "component": "web_ui__ProgressItemVertical__component",
  "disabled": "web_ui__ProgressItemVertical__disabled",
  "inner-content": "web_ui__ProgressItemVertical__inner-content",
  "clickable": "web_ui__ProgressItemVertical__clickable",
  "stepContainer": "web_ui__ProgressItemVertical__stepContainer",
  "column": "web_ui__ProgressItemVertical__column",
  "icon": "web_ui__ProgressItemVertical__icon",
  "icon--current": "web_ui__ProgressItemVertical__icon--current",
  "icon--current-active": "web_ui__ProgressItemVertical__icon--current-active",
  "icon--completed": "web_ui__ProgressItemVertical__icon--completed",
  "icon--completed-active": "web_ui__ProgressItemVertical__icon--completed-active",
  "icon--disabled-active": "web_ui__ProgressItemVertical__icon--disabled-active",
  "icon--disabled": "web_ui__ProgressItemVertical__icon--disabled",
  "icon-small": "web_ui__ProgressItemVertical__icon-small",
  "icon-small--completed-active": "web_ui__ProgressItemVertical__icon-small--completed-active",
  "icon-small--completed": "web_ui__ProgressItemVertical__icon-small--completed",
  "icon-small--error": "web_ui__ProgressItemVertical__icon-small--error",
  "icon-small--error-active": "web_ui__ProgressItemVertical__icon-small--error-active",
  "icon-small--disabled": "web_ui__ProgressItemVertical__icon-small--disabled",
  "icon-small--disabled-active": "web_ui__ProgressItemVertical__icon-small--disabled-active",
  "step-number": "web_ui__ProgressItemVertical__step-number",
  "step-number--active": "web_ui__ProgressItemVertical__step-number--active",
  "line": "web_ui__ProgressItemVertical__line",
  "dotted-line": "web_ui__ProgressItemVertical__dotted-line",
  "dotted-line-error": "web_ui__ProgressItemVertical__dotted-line-error",
  "item-completed": "web_ui__ProgressItemVertical__item-completed",
  "item-completed--small": "web_ui__ProgressItemVertical__item-completed--small",
  "dotted-line-small": "web_ui__ProgressItemVertical__dotted-line-small",
  "dotted-line-error-small": "web_ui__ProgressItemVertical__dotted-line-error-small",
  "title": "web_ui__ProgressItemVertical__title",
  "small": "web_ui__ProgressItemVertical__small",
  "icon-title--wrapper": "web_ui__ProgressItemVertical__icon-title--wrapper",
  "content": "web_ui__ProgressItemVertical__content",
  "suffix": "web_ui__ProgressItemVertical__suffix"
};

var _excluded = ["title", "caption", "showCaption", "number", "children", "progressionState", "size", "hasNextStep", "expanded", "lastItem", "onClick", "active", "suffix", "testId"],
  _excluded2 = ["aria-selected"];
var ProgressItemVertical = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _classNames;
  var title = _ref.title,
    caption = _ref.caption,
    showCaption = _ref.showCaption,
    number = _ref.number,
    children = _ref.children,
    _ref$progressionState = _ref.progressionState,
    progressionState = _ref$progressionState === void 0 ? 'current' : _ref$progressionState,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'Default' : _ref$size,
    hasNextStep = _ref.hasNextStep,
    expanded = _ref.expanded,
    _ref$lastItem = _ref.lastItem,
    lastItem = _ref$lastItem === void 0 ? !hasNextStep : _ref$lastItem,
    onClick = _ref.onClick,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? true : _ref$active,
    suffix = _ref.suffix,
    testId = _ref.testId,
    rest = _objectWithoutProperties(_ref, _excluded);
  var ariaSelected = rest['aria-selected'],
    restProps = _objectWithoutProperties(rest, _excluded2);
  var isExpanded = expanded !== null && expanded !== void 0 ? expanded : Boolean(ariaSelected);
  var isSmall = size === 'Small';
  var isProgressionCurrent = progressionState === 'current';
  var isProgressionCompleted = progressionState === 'completed';
  var isProgressionDisabled = progressionState === 'disabled';
  var isProgressionError = progressionState === 'error';
  var iconClass = classNames(styles.icon, (_classNames = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_classNames, styles['icon--completed'], isProgressionCompleted), styles['icon--completed-active'], active && isProgressionCompleted), styles['icon--current'], isProgressionCurrent && !active), styles['icon--current-active'], isProgressionCurrent && active), styles['icon--disabled'], isProgressionDisabled && !active), styles['icon--disabled-active'], isProgressionDisabled && active), styles['icon-small'], isSmall), styles['icon-small--current'], isSmall && isProgressionCurrent), styles['icon-small--completed-active'], isSmall && isProgressionCompleted && active), styles['icon-small--completed'], isSmall && isProgressionCompleted && !active), _defineProperty(_defineProperty(_classNames, styles['icon-small--error'], isSmall && isProgressionError && !active), styles['icon-small--error-active'], isSmall && isProgressionError && active)));
  var lineClass = classNames(styles.line, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles['dotted-line'], isProgressionCurrent || isProgressionDisabled || isProgressionError), styles['dotted-line-small'], isSmall && isProgressionCurrent || isSmall && isProgressionDisabled || isSmall && isProgressionError), styles['dotted-line-small--not-active'], isSmall && !active), styles['dotted-line-error'], isProgressionError), styles['dotted-line-error-small'], isProgressionError && isSmall), styles['dotted-line-disabled-small'], isProgressionDisabled && isSmall), styles['last-item'], lastItem), styles['item-completed'], isProgressionCompleted), styles['item-completed--small'], isSmall && isProgressionCompleted));
  var stepNumberClass = classNames(styles['step-number'], _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles['step-number--active'], isProgressionCurrent && active), styles['step-number--disabled'], isProgressionDisabled), styles['step-number--small'], isSmall && isProgressionCurrent), styles['step-number--small-completed'], isSmall && isProgressionCompleted), styles['step-number--small-disabled'], isSmall && isProgressionDisabled), styles['step-number--small-error'], isSmall && isProgressionError));
  var stepContainerClass = classNames(styles.stepContainer);
  var componentClass = classNames(styles.component, _defineProperty(_defineProperty({}, styles.clickable, onClick), styles.disabled, isProgressionDisabled));
  var titleClass = classNames(styles.title, _defineProperty({}, styles.small, isSmall));
  var renderCaption = function renderCaption() {
    if (!caption) return null;
    return /*#__PURE__*/jsx("div", {
      className: styles.caption,
      children: /*#__PURE__*/jsx(Text, {
        type: "caption",
        as: "p",
        children: caption
      })
    });
  };
  var renderInnerContent = function renderInnerContent() {
    return /*#__PURE__*/jsx("div", {
      role: "presentation",
      className: styles['inner-content'],
      onClick: function onClick(event) {
        return handleClick(event);
      },
      onKeyDown: function onKeyDown(event) {
        return handleKeydown(event);
      },
      children: /*#__PURE__*/jsx("div", {
        children: children
      })
    });
  };
  var renderSuffix = function renderSuffix() {
    if (!suffix) return null;
    return /*#__PURE__*/jsx("div", {
      className: styles.column,
      children: /*#__PURE__*/jsx("div", {
        className: styles.suffix,
        children: suffix
      })
    });
  };
  var props = _objectSpread(_objectSpread({}, restProps), {}, {
    onClick: onClick
  });
  return /*#__PURE__*/jsx("div", _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    className: componentClass
  }, props), isProgressionDisabled && {
    disabled: true
  }), {}, {
    "aria-expanded": isExpanded,
    "data-testid": testId,
    children: /*#__PURE__*/jsxs("div", {
      className: stepContainerClass,
      children: [/*#__PURE__*/jsxs("div", {
        className: styles.column,
        children: [renderIcon({
          progressionState: progressionState,
          active: active,
          size: size,
          iconClass: iconClass
        }) || renderNumber({
          number: number,
          iconClass: iconClass,
          stepNumberClass: stepNumberClass,
          progressionState: progressionState,
          active: active,
          size: size
        }), lastItem ? null : renderLine('vertical', progressionState, lineClass)]
      }), /*#__PURE__*/jsxs("div", {
        className: styles.column,
        children: [/*#__PURE__*/jsxs("div", {
          className: styles.content,
          children: [renderTitle({
            title: title,
            size: size,
            active: active,
            titleClass: titleClass
          }), /*#__PURE__*/jsx(Spacer, {
            size: "x-small"
          }), (showCaption !== null && showCaption !== void 0 ? showCaption : isExpanded) ? /*#__PURE__*/jsxs(Fragment, {
            children: [renderCaption(), /*#__PURE__*/jsx(Spacer, {
              size: "large"
            }), isExpanded ? renderInnerContent() : null]
          }) : null]
        }), /*#__PURE__*/jsx(Spacer, {
          orientation: "horizontal",
          size: isSmall ? 'medium' : 'x-large'
        })]
      }), renderSuffix()]
    })
  }));
});
ProgressItemVertical.displayName = 'ProgressItemVertical';

export { ProgressItemVertical as default };
//# sourceMappingURL=ProgressItemVertical.js.map
